import { Container, Row, Col } from "react-bootstrap";
import Shopintegrate from "../../components/shop_integrate";

const Manufacturerintegrate = () => {
  return (
    <>
      <Container>
        <div className="screenHeight">
          <Shopintegrate
            newshop="/manufacturer-form"
            url="/manufacturer-integrate-form"
          />
        </div>
      </Container>
    </>
  );
};

export default Manufacturerintegrate;
